(function () {
  function initPriceSlider(priceRange) {
    if (priceRange.querySelector('.cf-price-slider-wrap')) return;

    var fields = Array.prototype.slice.call(priceRange.querySelectorAll(':scope > .field'));
    if (fields.length < 2) return;

    var inputMin = fields[0].querySelector('input.field__input');
    var inputMax = fields[1].querySelector('input.field__input');
    if (!inputMin || !inputMax) return;

    // Inject $ symbol into each field
    [fields[0], fields[1]].forEach(function (field) {
      if (!field.querySelector('.cf-price-currency')) {
        var curr = document.createElement('span');
        curr.className = 'cf-price-currency';
        curr.textContent = '$';
        field.insertBefore(curr, field.firstChild);
      }
    });

    // Inject – separator between the two fields
    if (!priceRange.querySelector('.cf-price-separator')) {
      var sep = document.createElement('span');
      sep.className = 'cf-price-separator';
      sep.textContent = '–';
      fields[0].insertAdjacentElement('afterend', sep);
    }

    // Read bounds
    var minVal = parseFloat(inputMin.dataset.min) || 0;
    var maxVal = parseFloat(inputMax.dataset.max) || parseFloat(inputMin.dataset.max) || 100;
    var curMin = parseFloat(inputMin.value);
    var curMax = parseFloat(inputMax.value);
    if (isNaN(curMin)) curMin = minVal;
    if (isNaN(curMax)) curMax = maxVal;

    // Build slider wrapper (track + fill drawn via CSS ::before gradient)
    var wrap = document.createElement('div');
    wrap.className = 'cf-price-slider-wrap';

    var thumbMin = document.createElement('input');
    thumbMin.type = 'range';
    thumbMin.className = 'cf-price-range cf-price-range--min';
    thumbMin.setAttribute('data-min', minVal);
    thumbMin.setAttribute('data-max', maxVal);
    thumbMin.min = minVal;
    thumbMin.max = maxVal;
    thumbMin.value = curMin;
    thumbMin.step = 1;

    var thumbMax = document.createElement('input');
    thumbMax.type = 'range';
    thumbMax.className = 'cf-price-range cf-price-range--max';
    thumbMax.setAttribute('data-min', minVal);
    thumbMax.setAttribute('data-max', maxVal);
    thumbMax.min = minVal;
    thumbMax.max = maxVal;
    thumbMax.value = curMax;
    thumbMax.step = 1;

    wrap.appendChild(thumbMin);
    wrap.appendChild(thumbMax);
    priceRange.appendChild(wrap);

    // Update ::before gradient via CSS custom properties
    function updateFill() {
      var lo = parseFloat(thumbMin.value);
      var hi = parseFloat(thumbMax.value);
      var span = maxVal - minVal;
      if (span === 0) return;
      var pctLo = (lo - minVal) / span * 100;
      var pctHi = (hi - minVal) / span * 100;
      wrap.style.setProperty('--cf-lo', pctLo + '%');
      wrap.style.setProperty('--cf-hi', pctHi + '%');
    }

    updateFill();

    thumbMin.addEventListener('input', function () {
      if (parseFloat(thumbMin.value) > parseFloat(thumbMax.value)) {
        thumbMin.value = thumbMax.value;
      }
      inputMin.value = thumbMin.value;
      inputMin.dispatchEvent(new Event('change', { bubbles: true }));
      updateFill();
    });

    thumbMax.addEventListener('input', function () {
      if (parseFloat(thumbMax.value) < parseFloat(thumbMin.value)) {
        thumbMax.value = thumbMin.value;
      }
      inputMax.value = thumbMax.value;
      inputMax.dispatchEvent(new Event('change', { bubbles: true }));
      updateFill();
    });

    inputMin.addEventListener('change', function () {
      var v = parseFloat(inputMin.value);
      if (!isNaN(v)) {
        thumbMin.value = Math.min(v, parseFloat(thumbMax.value));
        updateFill();
      }
    });

    inputMax.addEventListener('change', function () {
      var v = parseFloat(inputMax.value);
      if (!isNaN(v)) {
        thumbMax.value = Math.max(v, parseFloat(thumbMin.value));
        updateFill();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('price-range.facets__price').forEach(initPriceSlider);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();

    // Re-init after Dawn replaces filter HTML via AJAX (innerHTML replacement)
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('price-range.facets__price')) {
            initPriceSlider(node);
          } else if (node.querySelector) {
            var found = node.querySelector('price-range.facets__price');
            if (found) initPriceSlider(found);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', initAll);
})();

/* ── Mobile drawer: neutralise Dawn's sub-menu behaviour ── */
(function () {
  function initDrawerFix() {
    var main = document.getElementById('FacetsWrapperMobile');
    if (!main || main._mdfBound) return;
    main._mdfBound = true;

    /* Dawn adds 'submenu-open' to #FacetsWrapperMobile and 'menu-opening'
       to the clicked <details>. These trigger CSS that hides the full list.
       Remove them as soon as they appear. */
    var observer = new MutationObserver(function (mutations) {
      var changed = false;
      mutations.forEach(function (m) {
        if (m.type !== 'attributes' || m.attributeName !== 'class') return;
        var el = m.target;
        if (el.classList.contains('submenu-open')) {
          el.classList.remove('submenu-open');
          changed = true;
        }
        if (el.classList.contains('menu-opening')) {
          el.classList.remove('menu-opening');
          changed = true;
        }
      });
    });

    observer.observe(main, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('DOMContentLoaded', initDrawerFix);
  document.addEventListener('shopify:section:load', initDrawerFix);
})();

/* ── Mobile filter bar ── */
(function () {
  var VIEW_KEY = 'ccg-mobile-view-v2';

  function getGrid() {
    return document.querySelector('#product-grid.ccg-grid');
  }

  function applyView(view) {
    var grid = getGrid();
    if (!grid) return;
    if (view === 'list') {
      grid.classList.add('ccg-grid--1col');
    } else {
      grid.classList.remove('ccg-grid--1col');
    }
  }

  function syncToggleUI(view) {
    document.querySelectorAll('.mfb__view-toggle').forEach(function (toggle) {
      toggle.setAttribute('data-active', view);
      toggle.querySelectorAll('.mfb__view-btn').forEach(function (btn) {
        var isActive = btn.dataset.view === view;
        btn.classList.toggle('mfb__view-btn--active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  }

  function initBar() {
    /* Filters button → trigger drawer summary */
    document.querySelectorAll('.mfb__btn--filter').forEach(function (btn) {
      if (btn.dataset.mfbBound) return;
      btn.dataset.mfbBound = '1';
      btn.addEventListener('click', function () {
        var container = btn.closest('.facets-container');
        if (!container) return;
        var summary = container.querySelector('.mobile-facets__wrapper summary');
        if (summary) summary.click();
      });
    });

    /* Sort select — sync with Dawn's hidden sort and trigger AJAX */
    document.querySelectorAll('.mfb__sort-select').forEach(function (select) {
      if (select.dataset.mfbBound) return;
      select.dataset.mfbBound = '1';
      select.addEventListener('change', function () {
        var dawnsSelect = document.querySelector('#SortBy-mobile');
        if (dawnsSelect) {
          dawnsSelect.value = select.value;
          dawnsSelect.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          window.location.href = url.toString();
        }
      });
    });

    /* Card view toggle */
    document.querySelectorAll('.mfb__view-btn').forEach(function (btn) {
      if (btn.dataset.mfbBound) return;
      btn.dataset.mfbBound = '1';
      btn.addEventListener('click', function () {
        var view = btn.dataset.view;
        localStorage.setItem(VIEW_KEY, view);
        applyView(view);
        syncToggleUI(view);
      });
    });

    /* Restore saved view */
    var saved = localStorage.getItem(VIEW_KEY) || 'list';
    applyView(saved);
    syncToggleUI(saved);
  }

  document.addEventListener('DOMContentLoaded', initBar);
  document.addEventListener('shopify:section:load', initBar);

  /* Re-apply view after Dawn AJAX replaces the grid */
  var gridObserver = new MutationObserver(function () {
    var saved = localStorage.getItem(VIEW_KEY) || 'list';
    applyView(saved);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('#ProductGridContainer');
    if (container) {
      gridObserver.observe(container, { childList: true, subtree: false });
    }
  });
})();
